module.exports = __webpack_public_path__ + "img/overView_banner_mobile.79ed97fa.jpg";